import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDegreeData,
  postDegreeRegistration,
  fetchDegreeNames,
} from "../../redux/slicer/degreeSlice";
import Background from "../../assets/background_2.png";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import { isValidPhoneNumber } from "libphonenumber-js";
import { Await, useLocation, useNavigate } from "react-router-dom";
import { FaRegLightbulb } from "react-icons/fa";

function DegreeRegistrationApply() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const degreeName = searchParams.get("name");
  const [formData, setFormData] = useState({
    degree_type: "",
    week_type: "",
    name_with_initials: "",
    full_name: "",
    date_of_birth: "",
    nationality: "",
    nic: "",
    mailing_address: "",
    permanent_address: "",
    mobile_no: "",
    home_no: "",
    email_address: "",
    al_school: "",
    al_index_no: "",
    al_year: "",
    al_stream: "",
    al_medium: "",
    ol_school: "",
    ol_index_no: "",
    ol_year: "",
    ol_maths_result: "",
    name_of_the_examination: "",
    institute: "",
    country: "",
    year: "",
    medium: "",
    sl_al_details: [
      { subject: "General English", grade: "" },
      { subject: "Common General Paper (New Syllabus)", grade: "" },
      { subject: "", grade: "" },
      { subject: "", grade: "" },
      { subject: "", grade: "" },
    ],
    foreign_educational_details: Array(8).fill({ subject: "", grade: "" }),
    extra_curricular_activities: [
      {
        activity: "",
        achievement: "",
        achievemnet_year: "",
      },
    ],
    advertisement_media: "",
    advertised_paper: "",
    other_media: "",
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const dispatch = useDispatch();

  const {
    data: degreeNameData,
    DegreeLoading,
    DegreeError,
  } = useSelector((state) => state.degree.degreeName);

  useEffect(() => {
    dispatch(fetchDegreeNames());
  }, [dispatch]);

  // State for phone input raw values and error messages
  const [mobileValue, setMobileValue] = useState("");
  const [homeValue, setHomeValue] = useState("");
  const [emailValue, setEmailValue] = useState("");

  const [selectedOption, setSelectedOption] = useState("");
  const [advertisementInput, setAdvertisementInput] = useState("");
  const [otherInput, setOtherInput] = useState("");
  const [programType, setProgramType] = useState("");
  const [nicPassportError, setNicPassportError] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [homeNoError, setHomeNoError] = useState("");
  const [emailError, setEmailError] = useState("");

  const normalizePhoneNumber = (phone) => {
    if (!phone) return phone;
    // Keep only digits and the leading '+' for the country code
    return phone.replace(/[\s-]/g, "");
  };

  const validatePhoneNumber = (phoneValue, type) => {
    const normalizedPhone = normalizePhoneNumber(phoneValue);
    const setError = type === "mobile" ? setMobileNoError : setHomeNoError;

    setError(""); // Clear previous error
    if (normalizedPhone) {
      if (normalizedPhone.startsWith("+94")) {
        if (!isValidPhoneNumber(normalizedPhone, "LK")) {
          setError(
            `Please enter a valid Sri Lankan ${type} number, without 0. (eg: 712345678)`
          );
          return false;
        }

        if (normalizedPhone.length !== 12) {
          setError(
            `Sri Lankan ${type} number including the country code +94 must be 12 digits.`
          );
          return false;
        }
      } else {
        if (!isValidPhoneNumber(normalizedPhone)) {
          setError(`Please enter a valid international ${type} number.`);
          return false;
        }
      }
    }

    return true;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    setEmailError("");

    if (!email) {
      setEmailError("Email address is required.");
      return false;
    }

    if (!emailRegex.test(email)) {
      setEmailError("Invalid email format.");
      return false;
    }
    return true;
  };

  const handlePhoneChange = (phoneValue, type) => {
    if (type === "mobile") {
      setMobileValue(phoneValue);
      validatePhoneNumber(phoneValue, type);
    } else {
      setHomeValue(phoneValue);
      validatePhoneNumber(phoneValue, type);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === "nic") {
      validateNicPassport(value);
    }
    if (name === "email_address") {
      validateEmail(value);
    }
  };

  const handleOptionChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    setFormData((prevFormData) => {
      let updatedFormData = {
        ...prevFormData,
        advertisement_media: "",
        advertised_paper: "",
        other_media: "",
      };

      if (selectedValue === "Advertisement") {
        updatedFormData.advertisement_media = selectedValue;
      } else if (selectedValue === "Other") {
        updatedFormData.other_media = selectedValue;
      } else {
        updatedFormData.advertisement_media = selectedValue; // Store other options in advertisement_media
      }

      return updatedFormData;
    });

    // Clear input fields when radio selection changes
    setAdvertisementInput("");
    setOtherInput("");
  };

  const handleProgramTypeChange = (e) => {
    setProgramType(e.target.value);
    setFormData((prevFormData) => ({
      ...prevFormData,
      week_type: e.target.value, // Update week_type in formData
    }));
  };

  const validateNicPassport = (nicPassport) => {
    setNicPassportError("");
    if (!nicPassport) {
      return true;
    }

    // Passport validation (9 characters)
    const passportRegex = /^[a-zA-Z0-9]{9}$/;

    const nicRegexWithV = /^[0-9]{9}[Vv]$/;
    const nicRegexWithoutV = /^[0-9]{12}$/;

    if (nicRegexWithV.test(nicPassport)) {
      if (nicPassport.length !== 10) {
        setNicPassportError("Old NIC must be 10 characters long.");
        return false;
      }
      return true;
    } else if (nicRegexWithoutV.test(nicPassport)) {
      if (nicPassport.length !== 12) {
        setNicPassportError("New NIC must be 12 characters long.");
        return false;
      }
      return true;
    } else if (passportRegex.test(nicPassport)) {
      return true; // Passport is valid
    } else {
      setNicPassportError(
        "Invalid NIC/Passport format.  Must be 9 characters for passport."
      );
      return false;
    }
  };

  const addActivity = () => {
    setFormData((prevState) => ({
      ...prevState,
      extra_curricular_activities: [
        ...prevState.extra_curricular_activities,
        { activity: "", achievement: "", achievemnet_year: "" },
      ],
    }));
  };

  const removeActivity = (index) => {
    setFormData((prevState) => ({
      ...prevState,
      extra_curricular_activities: prevState.extra_curricular_activities.filter(
        (_, i) => i !== index
      ),
    }));
  };

  const handleActivityChange = (e, index, field) => {
    const updatedActivities = [...formData.extra_curricular_activities];
    updatedActivities[index][field] = e.target.value;
    setFormData((prevState) => ({
      ...prevState,
      extra_curricular_activities: updatedActivities,
    }));
  };
  const handleForeignDetailsChange = (e, index, field) => {
    const updatedDetails = [...formData.foreign_educational_details];
    updatedDetails[index] = {
      ...updatedDetails[index],
      [field]: e.target.value,
    };
    setFormData((prevState) => ({
      ...prevState,
      foreign_educational_details: updatedDetails,
    }));
  };
  const handleTableChange = (value, index, field) => {
    const updatedDetails = [...formData.sl_al_details];
    updatedDetails[index][field] = value;
    setFormData({ ...formData, sl_al_details: updatedDetails });
  };

  const currentYear = new Date().getFullYear();
  const yearOptions = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, index) => 1900 + index
  ).reverse(); // Reverse to display from current year to 1900

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSuccessMessage("");
    setErrorMessage("");
    setMobileNoError("");
    setNicPassportError("");
    if (!formData.week_type) {
      setErrorMessage("Please select the program type (Weekday/Weekend).");
      setShowPopup(true);
      setNicPassportError("");
      return;
    }
    if (!formData.degree_type) {
      setErrorMessage("Please select the degree type");
      setShowPopup(true);
      setNicPassportError("");
      return;
    }
    const isValidNicPassport = validateNicPassport(formData.nic);
    if (!isValidNicPassport) {
      return;
    }

    // Validate mobile number and email here, before submission
    const isMobileValid = validatePhoneNumber(mobileValue, "mobile");
    const isEmailValid = validateEmail(formData.email_address);

    if (!isMobileValid || !isEmailValid) {
      // Prevent submission if there are mobile or email validation errors
      return;
    }

    // Normalize phone numbers
    const normalizedMobilePhone = normalizePhoneNumber(mobileValue);
    const normalizedHomePhone = normalizePhoneNumber(homeValue);

    // Remove empty subject-grade pairs
    const filteredDetails = formData.sl_al_details.filter(
      (item) => item.subject.trim() !== "" || item.grade.trim() !== ""
    );

    const dataToSubmit = {
      ...formData,
      mobile_no: normalizedMobilePhone,
      home_no: normalizedHomePhone,
      sl_al_details: filteredDetails,
    };

    try {
      const response = await dispatch(postDegreeRegistration(dataToSubmit));

      if (response?.success) {
        setSuccessMessage(response.message); // Display success message from the backend
        setShowPopup(true); // Show the success popup Show success popup
        // Reset form fields
        setFormData((prevState) => ({
          // Use prevState for correct reset
          ...prevState,
          degree_type: "",
          week_type: "",
          name_with_initials: "",
          full_name: "",
          date_of_birth: "",
          nationality: "",
          nic: "",
          mailing_address: "",
          permanent_address: "",
          mobile_no: "",
          home_no: "",
          email_address: "",
          al_school: "",
          al_index_no: "",
          al_year: "",
          al_stream: "",
          al_medium: "",
          ol_school: "",
          ol_index_no: "",
          ol_year: "",
          ol_maths_result: "",
          name_of_the_examination: "",
          institute: "",
          country: "",
          year: "",
          medium: "",
          advertisement_media: "",
          advertised_paper: "",
          other_media: "",
          sl_al_details: [
            { subject: "General English", grade: "" },
            { subject: "Common General Paper (New Syllabus)", grade: "" },
            { subject: "", grade: "" },
            { subject: "", grade: "" },
            { subject: "", grade: "" },
          ],
          foreign_educational_details: Array(8).fill({
            subject: "",
            grade: "",
          }),
          extra_curricular_activities: [
            {
              activity: "",
              achievement: "",
              achievemnet_year: "",
            },
          ],
        }));
        setMobileValue("");
        setHomeValue("");
        setEmailValue(""); // Clear email input
      } else {
        throw new Error(response?.message || "Something went wrong");
      }
    } catch (error) {
      setErrorMessage(error.message);
      setShowPopup(true); // Show the error popup
    }
  };
  const closePopup = () => {
    setShowPopup(false);
  };
  if (DegreeLoading) return <div>Loading...</div>;
  if (DegreeError) return <div>Error: {DegreeError}</div>;

  return (
    <div className="relative max-w-full mx-auto ">
      <div className="contain overflow-hidden w-full h-[300px]">
        <img
          src={Background}
          alt="carousel-slide"
          className="w-full h-full object-cover object-center"
        />
      </div>

      <div className="py-6 px-10 grid ">
        <h2 className="text-4xl text-primary-color mt-5">Select Degree</h2>
        <div className="flex justify-center items-center h-full w-full">
          <select
            name="degree_type"
            value={formData.degree_type}
            onChange={handleInputChange}
            className="border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-2 font-inter mt-5
               w-full md:w-3/4 lg:w-1/2 xl:w-1/3" // Responsive widths
          >
            <option value="">Select Degree Program</option>
            {degreeNameData.map((degree) => (
              <option key={degree.id} value={degree.id}>
                {degree.program_name}
              </option>
            ))}
          </select>
        </div>

         {/* <h2 className="text-4xl text-primary-color mt-5">Select Degree</h2>
        <div className="flex justify-center items-center h-full w-full">
          <select
            name="degree_type"
            value={formData.degree_type}
            onChange={handleInputChange}
            className="w-md border-b-2 border-gray-300 focus:outline-none focus:border-primary-color text-gray-700 py-2 font-inter mt-5"
          >
            <option value="">Select Degree Program</option>
            {degreeNameData.map((degree) => (
              <option key={degree.id} value={degree.id}>
                {degree.program_name}
              </option>
            ))}
          </select>
        </div> */}

        <form action="" className="mt-6 py-6 " onSubmit={handleSubmit}>
          <div className="py-10 px-4 sm:px-6 md:px-10 lg:px-20 xl:px-28 mt-6">
            <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
              <h2 className="text-primary-color font-bold text-xl md:text-2xl">
                1. Program applying for* :
              </h2>
              <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                <label className="flex items-center gap-2 text-primary-color text-lg md:text-xl">
                  <input
                    type="radio"
                    name="programType"
                    value="Weekday"
                    checked={programType === "Weekday"}
                    onChange={handleProgramTypeChange}
                    className="form-radio text-primary-color"
                  />
                  Weekday
                </label>
                <label className="flex items-center gap-2 text-primary-color text-lg md:text-xl">
                  <input
                    type="radio"
                    name="programType"
                    value="Weekend"
                    checked={programType === "Weekend"}
                    onChange={handleProgramTypeChange}
                    className="form-radio text-primary-color"
                  />
                  Weekend
                </label>
              </div>
            </div>
          </div>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-6 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <h2 className="text-primary-color text-2xl font-bold text-left">
              2. Application Information
            </h2>

            <div>
              <label htmlFor="name" className="text-primary-color flex">
                2.1 Name (Mr./Mrs./Miss/Ms.)
              </label>
              <input
                type="text"
                name="name_with_initials"
                value={formData.name_with_initials}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
            </div>

            <div>
              <label htmlFor="name" className="text-primary-color flex">
                2.2 Full Name
              </label>
              <input
                type="text"
                name="full_name"
                value={formData.full_name}
                onChange={handleInputChange}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 gap-6">
              <div>
                <label
                  htmlFor="date_of_birth"
                  className="text-primary-color flex"
                >
                  2.3 Date Of Birth
                </label>
                <input
                  type="date"
                  name="date_of_birth"
                  value={formData.date_of_birth}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="nationality"
                  className="text-primary-color flex"
                >
                  2.4 Nationality
                </label>
                <input
                  type="text"
                  name="nationality"
                  value={formData.nationality}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                />
              </div>

              <div>
                <label htmlFor="nic" className="text-primary-color flex">
                  2.5 NIC (For Sri Lankan Applicants)/Passport No.
                </label>
                <input
                  type="text"
                  name="nic"
                  value={formData.nic}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                />
                {nicPassportError && (
                  <p className="text-red-600 mt-1">{nicPassportError}</p>
                )}
              </div>
            </div>
          </div>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-8 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <h2 className="text-primary-color text-2xl font-bold text-left">
              3. Contact Information
            </h2>

            <div>
              <label
                htmlFor="mailing_address"
                className="text-primary-color flex"
              >
                3.1 Mailing Address
              </label>
              <input
                type="text"
                name="mailing_address"
                value={formData.mailing_address}
                onChange={handleInputChange}
                className="w-full h-[110px] p-2 border border-primary-color rounded mt-2"
                required
              />
            </div>
            <div>
              <label
                htmlFor="permanent_address"
                className="text-primary-color flex"
              >
                3.2 Permanet Address(if Different fromabove)
              </label>
              <input
                type="text"
                name="permanent_address"
                value={formData.permanent_address}
                onChange={handleInputChange}
                className="w-full h-[110px] p-2 border border-primary-color rounded mt-2"
              />
            </div>

            <div className="grid grid-cols-1  lg:grid-cols-2  xl:grid-cols-2  md:grid-cols-1   gap-6">
              <div>
                <label
                  htmlFor="mobile_number"
                  className="text-primary-color flex"
                >
                  3.3 Mobile
                </label>
                <PhoneInput
                  placeholder="Enter phone number"
                  name="mobile_no"
                  value={mobileValue}
                  onChange={(value) => handlePhoneChange(value, "mobile")}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                  required
                />
                {mobileNoError && (
                  <p className="text-red-600 mt-1">{mobileNoError}</p>
                )}
              </div>

              <div>
                <label
                  htmlFor="mobile_number"
                  className="text-primary-color flex"
                >
                  3.4 Home
                </label>
                <PhoneInput
                  placeholder="Enter phone number"
                  name="home_no"
                  value={homeValue}
                  onChange={(value) => handlePhoneChange(value, "home")}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
                {homeNoError && (
                  <p className="text-red-600 mt-1">{homeNoError}</p>
                )}
              </div>
            </div>
            <div>
              <label
                htmlFor="email_address"
                className="text-primary-color flex"
              >
                3.5 Email Address*
              </label>
              <input
                type="text"
                name="email_address"
                value={formData.email_address}
                onChange={(e) => {
                  handleInputChange(e); // First, update the form data
                  validateEmail(e.target.value); // Then validate email
                }}
                className="w-full p-2 border border-primary-color rounded mt-2"
                required
              />
              {emailError && <p className="text-red-600 mt-1">{emailError}</p>}
            </div>
          </div>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-8 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <h2 className="text-primary-color text-2xl font-bold text-left">
              4. Education Qualifications
            </h2>

            <h2 className="text-primary-color text-left">
              4.1 G.C.E A/L Examination (Sri Lanka)
            </h2>

            <div className="grid grid-cols-1  lg:grid-cols-3  xl:grid-cols-3 md:grid-cols-1 sm:grid-cols-1 gap-10">
              <div>
                <label htmlFor="al_school" className="text-primary-color flex">
                  School*
                </label>
                <input
                  type="text"
                  name="al_school"
                  value={formData.al_school}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
              </div>

              <div>
                <label
                  htmlFor="al_index_no"
                  className="text-primary-color flex"
                >
                  Index No*
                </label>
                <input
                  type="text"
                  name="al_index_no"
                  value={formData.al_index_no}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
              </div>

              <div>
                <label htmlFor="al_year" className="text-primary-color flex">
                  Year *
                </label>
                <select
                  name="al_year"
                  value={formData.al_year}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                >
                  <option value="">-- Select Year --</option>
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <label htmlFor="al_stream" className="text-primary-color flex">
                  Stream*
                </label>
                <select
                  name="al_stream"
                  value={formData.al_stream}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                >
                  <option value="">-- Select Stream --</option>
                  <option value="Combined Maths">Combined Maths</option>
                  <option value="Biology">Biology</option>
                  <option value="Commerce">Commerce</option>
                  <option value="Art">Art</option>
                  <option value="Tech">Tech</option>
                </select>
              </div>

              <div>
                <label htmlFor="al_medium" className="text-primary-color flex">
                  Medium*
                </label>
                <select
                  name="al_medium"
                  value={formData.al_medium}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                >
                  <option value="">-- Select Medium --</option>
                  <option value="Sinhala">Sinhala</option>
                  <option value="English">English</option>
                  <option value="Tamil">Tamil</option>
                </select>
              </div>
            </div>
            <div className="py-6">
              <table className="w-full border-collapse border border-primary-color">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-200 px-4 py-2 text-left text-primary-color">
                      Subjects
                    </th>
                    <th className="border border-gray-200 px-4 py-2 text-left text-primary-color">
                      Grade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formData.sl_al_details.map((item, index) => (
                    <tr key={index}>
                      <td className="border border-gray-200 px-4 py-2 text-gray-700">
                        <input
                          type="text"
                          value={item.subject}
                          disabled={index < 2} // Disable editing for static subjects
                          placeholder={`Enter Subject ${index + 1}`}
                          onChange={(e) =>
                            handleTableChange(e.target.value, index, "subject")
                          }
                          className={`w-full px-2 py-1 rounded ${
                            index < 2 ? "text-primary-color" : ""
                          }`}
                        />
                      </td>
                      <td className="border border-gray-200 px-4 py-2 text-gray-700">
                        <input
                          type="text"
                          value={item.grade}
                          placeholder="Enter The Grade"
                          onChange={(e) =>
                            handleTableChange(e.target.value, index, "grade")
                          }
                          className="w-full px-2 py-1 rounded"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div>
              <h2 className="text-primary-color text-left">
                4.2 G.C.E O/L Examination (Sri Lanka)
              </h2>
              <div className="grid grid-cols-1  lg:grid-cols-3  xl:grid-cols-3 md:grid-cols-1 gap-10 mt-6">
                <div>
                  <label
                    htmlFor="ol_school"
                    className="text-primary-color flex"
                  >
                    School*
                  </label>
                  <input
                    type="text"
                    name="ol_school"
                    value={formData.ol_school}
                    onChange={handleInputChange}
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  />
                </div>

                <div>
                  <label
                    htmlFor="ol_index_no"
                    className="text-primary-color flex"
                  >
                    Index No*
                  </label>
                  <input
                    type="text"
                    name="ol_index_no"
                    value={formData.ol_index_no}
                    onChange={handleInputChange}
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  />
                </div>

                <div>
                  <label htmlFor="ol_year" className="text-primary-color flex">
                    Year *
                  </label>
                  <select
                    name="ol_year"
                    value={formData.ol_year}
                    onChange={handleInputChange}
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  >
                    <option value="">-- Select Year --</option>
                    {yearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label
                    htmlFor="ol_maths_result"
                    className="text-primary-color flex"
                  >
                    Mathematics Result*
                  </label>
                  <input
                    type="text"
                    name="ol_maths_result"
                    value={formData.ol_maths_result}
                    onChange={handleInputChange}
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-8 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <h2 className="text-primary-color text-2xl font-bold text-left">
              5. Foreign Educational Qualifications Equivalent to the GCE A/L
              Examination (Sri Lanka)
            </h2>
            <div className="grid grid-cols-1  lg:grid-cols-3 xl:grid-cols-3 md:grid-cols-1 gap-10">
              <div>
                <label
                  htmlFor="name_of_the_examination"
                  className="text-primary-color flex"
                >
                  5.1 Name Of the Examination *
                </label>
                <input
                  type="text"
                  name="name_of_the_examination"
                  value={formData.name_of_the_examination}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
              </div>
            </div>

            <div className="grid grid-cols-1  lg:grid-cols-3 xl:grid-cols-3 md:grid-cols-1 gap-10">
              <div>
                <label htmlFor="institute" className="text-primary-color flex">
                  School/College/Institute *
                </label>
                <input
                  type="text"
                  name="institute"
                  value={formData.institute}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
              </div>

              <div>
                <label htmlFor="country" className="text-primary-color flex">
                  Country*
                </label>
                <input
                  type="text"
                  name="country"
                  value={formData.country}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
              </div>

              <div>
                <label htmlFor="year" className="text-primary-color flex">
                  Year *
                </label>
                <select
                  name="year"
                  value={formData.year}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                >
                  <option value="">-- Select Year --</option>
                  {yearOptions.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="grid grid-cols-1  lg:grid-cols-3 xl:grid-cols-3 md:grid-cols-1 gap-10">
              <div>
                <label htmlFor="medium" className="text-primary-color flex">
                  medium*
                </label>
                <input
                  type="text"
                  name="medium"
                  value={formData.medium}
                  onChange={handleInputChange}
                  className="w-full p-2 border border-primary-color rounded mt-2"
                />
              </div>
            </div>
            <div className="py-6">
              <table className="w-full border-collapse border border-primary-color">
                <thead>
                  <tr className="bg-gray-50">
                    <th className="border border-gray-200 px-4 py-2 text-left text-primary-color">
                      Subjects
                    </th>
                    <th className="border border-gray-200 px-4 py-2 text-left text-primary-color">
                      Grade
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {formData.foreign_educational_details.map((item, index) => (
                    <tr key={index}>
                      <td className="border border-gray-200 px-4 py-2 text-gray-700">
                        <input
                          type="text"
                          name={`subject-${index}`}
                          value={item.subject}
                          onChange={(e) =>
                            handleForeignDetailsChange(e, index, "subject")
                          }
                          placeholder={`Enter Subject ${index + 1}`}
                          className="w-full px-2 py-1 rounded"
                        />
                      </td>
                      <td className="border border-gray-200 px-4 py-2 text-gray-700">
                        <input
                          type="text"
                          name={`grade-${index}`}
                          value={item.grade}
                          onChange={(e) =>
                            handleForeignDetailsChange(e, index, "grade")
                          }
                          placeholder="Enter Grade"
                          className="w-full px-2 py-1 rounded"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <p className="text-primary-color font-bold text-justify ">
              *Applicants with foreign educational qualifications equivalent to
              the GCE A/L Examination (Sri Lanka) (other than Edexcel and
              Cambridge International Examinations) are required to attach to
              their applications, with the original letter obtained from the
              Examinations Board concerned, to prove that their educational
              qualifications are equivalent to the G.C.E. A/L Examination of the
              University of London or qualifications required for admission to a
              university in their own country to follow an undergraduate course
              of study leading to a Bachelor’s Degree.
            </p>
          </div>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-8 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <h2 className="text-primary-color text-2xl font-bold text-left">
              6. Sports and Extra Curricular Achievements
            </h2>

            {formData.extra_curricular_activities.map((activity, index) => (
              <div
                className="grid grid-cols-1  lg:grid-cols-3 xl:grid-cols-3 md:grid-cols-1 gap-10"
                key={index}
              >
                <div>
                  <label
                    htmlFor={`activity-${index}`}
                    className="text-primary-color flex"
                  >
                    Sports/Extra Curricular Activity*
                  </label>
                  <input
                    type="text"
                    name="activity"
                    value={activity.activity}
                    onChange={(e) => handleActivityChange(e, index, "activity")}
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  />
                </div>

                <div>
                  <label
                    htmlFor={`achievement-${index}`}
                    className="text-primary-color flex"
                  >
                    Achievements*
                  </label>
                  <input
                    type="text"
                    name="achievement"
                    value={activity.achievement}
                    onChange={(e) =>
                      handleActivityChange(e, index, "achievement")
                    }
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  />
                </div>

                <div>
                  <label
                    htmlFor={`achievemnet_year-${index}`}
                    className="text-primary-color flex"
                  >
                    Year *
                  </label>
                  <select
                    name="achievemnet_year"
                    value={activity.achievemnet_year}
                    onChange={(e) =>
                      handleActivityChange(e, index, "achievemnet_year")
                    }
                    className="w-full p-2 border border-primary-color rounded mt-2"
                  >
                    <option value="">-- Select Year --</option>
                    {yearOptions.map((year) => (
                      <option key={year} value={year}>
                        {year}
                      </option>
                    ))}
                  </select>
                </div>

                <button
                  type="button"
                  onClick={() => removeActivity(index)}
                  className="mt-6  text-white p-2 rounded w-[120px]"
                >
                  Remove
                </button>
              </div>
            ))}

            <button
              type="button"
              onClick={addActivity}
              className="flex justify-center  item-center w-[120px] mt-6  bg-primary-color text-white p-2 rounded"
            >
              Add Activity
            </button>
          </div>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-8 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <h2 className="text-primary-color text-2xl font-bold text-left">
              7. How did you get to know about the above degree programme?
            </h2>

            <div className="grid grid-cols-2  lg:grid-cols-5 xl:grid-cols-6 md:grid-cols-2 gap-y-4 gap-x-6 text-primary-color">
              {[
                "Advertisement",
                "Website",
                "Social Media",
                "Radio",
                "E-Flyer",
                "Exhibition",
                "Workshop",
                "Other",
              ].map((option) => (
                <label key={option} className="flex items-center space-x-2">
                  <input
                    type="radio"
                    name="infoSource"
                    value={option}
                    checked={selectedOption === option}
                    onChange={handleOptionChange}
                    className="w-4 h-4 text-primary-color border-primary-color focus:ring-primary-color"
                  />
                  <span className="text-primary-color">{option}</span>
                </label>
              ))}
            </div>

            {selectedOption === "Advertisement" && (
              <div className="mt-4">
                <input
                  type="text"
                  placeholder="Specify the paper"
                  value={advertisementInput}
                  onChange={(e) => setAdvertisementInput(e.target.value)}
                  className="w-full px-4 py-2 border border-primary-color rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                />
              </div>
            )}
            {selectedOption === "Other" && (
              <div className="mt-4">
                <input
                  type="text"
                  placeholder="Please specify the name"
                  value={otherInput}
                  onChange={(e) => setOtherInput(e.target.value)}
                  className="w-full px-4 py-2 border border-primary-color rounded-md focus:outline-none focus:ring-2 focus:ring-primary-color"
                />
              </div>
            )}
          </div>

          <h2 className="mt-5 text-left text-primary-color font-bold">
            Please read the below guidelines carefully before the submission.
          </h2>

          <div className="grid gap-y-6 border-dotted border-2 border-primary-color rounded-xl py-10 px-6 sm:py-12 sm:px-8 md:py-16 md:px-20 lg:py-20 lg:px-28 mt-6">
            <div className="flex text-primary-color gap-3 text-xl">
              <span>
                <FaRegLightbulb />{" "}
              </span>
              <h2 className=" text-left text-primary-color font-bold">
                Guidelines to Applicants
              </h2>
            </div>

            <h2 className="text-left text-primary-color">
              An individual who satisfies the specified entry requirements, is
              entitled to apply for the BSc. in Applied Accounting
              (General/Honours) Degree
            </h2>
            <div className="grid gap-6">
              <h2 className="text-left text-primary-color">
                Please read the following instructions before completing the
                application
              </h2>
              <ul className="text-left text-primary-color list-disc grid  gap-y-4">
                <li>
                  Application form should be filled in English by using BLOCK
                  CAPITAL LETTERS. Name must be given as appearing in the Birth
                  Certificate. (Box 2)
                  <div className="grid gap-3 ml-5 mt-5">
                    {" "}
                    <h2>
                      <div className="flex">
                        <span> Example: Name with initials: </span>
                        <h2 className="font-bold ml-3">
                          D.A.S. WEERASEKARA (Box 2.1)
                        </h2>{" "}
                      </div>
                    </h2>
                    <h2>
                      <div className="flex">
                        <span> Full Name </span>
                        <h2 className="font-bold ml-3">
                          DISSANAYAKA ARACHCHIGE SAMAN WEERASEKARA (Box 2.2)
                        </h2>{" "}
                      </div>
                    </h2>
                  </div>
                </li>

                <li>
                  {" "}
                  G.C.E. Advanced Level examination results should be indicated
                  accurately and clearly. (Box 4.1)
                </li>

                <li>
                  Duly completed application along with the Cash Deposit Slip,
                  copy of the NIC, copy of G.C.E. Ordinary Level (O/L) and
                  G.C.E. Advanced Level (A/L) certificate be emailed to{" "}
                  <a href="" className="underline">
                    {" "}
                    sab@casrilanka.org
                  </a>
                </li>
                <div className="flex justify-center item-center">
                  {" "}
                  <div className="p-4 md:p-8 bg-white grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 flex justify-center item-center">
                    <div className="border-dotted border-2 border-primary-color rounded-xl p-6 text-left bg-[#92288C36]">
                      <h2>
                        {" "}
                        For further information, please contact:
                        <h2 className="font-bold text-left">
                          SAB Campus, CA Sri Lanka 411, Galle Road Colombo 4
                        </h2>
                      </h2>
                    </div>

                    <div className="border-dotted border-2 border-primary-color rounded-xl p-6 text-left bg-[#92288C36] ">
                      <div className="flex">
                        <span> Hot Line : – </span>
                        <h2 className="font-bold ml-3">
                          0112 101 044 / 071 0235 263
                        </h2>{" "}
                      </div>

                      <div className="flex">
                        <span> Email : – </span>
                        <h2 className="font-bold ml-3">
                          sab@casrilanka.org
                        </h2>{" "}
                      </div>
                      <h2>
                        {" "}
                        <a href="">www.casrilanka.com</a>
                      </h2>
                    </div>
                  </div>
                </div>
              </ul>
            </div>
          </div>

          <button
            type="submit"
            className="mt-6 bg-primary-color text-white p-2 rounded"
          >
            Submit Registration
          </button>

          {showPopup && (
            <div className="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-50 z-50">
              <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg relative">
                <button
                  type="button"
                  onClick={closePopup}
                  className="absolute top-4 right-4 text-gray-500 hover:text-black text-2xl"
                >
                  ×
                </button>
                <h3 className="text-xl font-bold text-primary-color mb-4">
                  Information
                </h3>
                <p className="text-black">
                  {successMessage || errorMessage || "Somthing Went Wrong."}
                </p>
                <div className="mt-6 flex justify-end">
                  <button
                    onClick={closePopup}
                    className="bg-primary-color text-white px-4 py-2 rounded"
                  >
                    Okay
                  </button>
                </div>
              </div>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default DegreeRegistrationApply;
